import { COVERGO_SAAS_DEV } from "../consts.js"

export const laya_dev = {
	"laya-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "laya_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
